<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yc5Ydy/images/9781455572243_cover_epub.jpg?1733085690299" alt="This image is the cover for the book Maverick of Copper Creek, Copper Creek Cowboys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maverick of Copper Creek, Copper Creek Cowboys
      </h1>
      <p class="bookDescription body article font2">
        <p>"Found love, lost treasure and ever-present danger. R.C. Ryan delivers it all with page-turning romance." -- Nora Roberts, <i>New York Times </i>bestselling author.<br/><br/> A Copper Creek Cowboys Novel<br/><br/> First love always burns hotter . . .<br/><br/> Ash MacKenzie broke his share of hearts when he left Copper Creek all those years ago and struck out on his own. Tall, tough, and proud. That's how Brenna always remembered him, and from the looks of things, he hasn't changed much. Once, she thought he could save her-whisk her away from her rough childhood home and start fresh together. Now she knows better . . . <br/><br/> Ash isn't planning to stick around town long. As soon as he uncovers the truth about his father's death and makes sure the family ranch is safe, he'll be back out on his own. And then he runs into Brenna Crane. It broke his heart to leave her once-a herd of stampeding horses couldn't make him do it again. But Brenna has made a new life for herself, one that doesn't include him. Now he just has to convince her to give their first love a second chance.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.C. Ryan
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> bestselling author <B>R.C. Ryan</B> has written more than ninety novels, both contemporary and historical.  Quite an accomplishment for someone who, after her fifth child started school, gave herself the gift of an hour a day to follow her dream to become a writer. <br><br> In a career spanning more than twenty years, Ms. Ryan has given dozens of radio, television, and print interviews across the country and Canada, and has been quoted in such diverse publications as the <I>Wall Street Journal</I> and <I>Cosmopolitan</I>.  She has also appeared on <I>CNN News</I> and <I>Good Morning America</I>. <br><br> R.C. Ryan is a pseudonym of <I>New York Times</I> bestselling author Ruth Ryan Langan.<br><br> You can learn more about R. C. Ryan and her alter ego Ruth Ryan Langan at:<br> RyanLangan.com<br> Twitter, @RuthRyanLangan<br> Facebook.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cd307f5